export function generateRoute(route: string, params: object = {}): string {
    let routeStr = route;
    for ( const key in params ) {
        if ( key && params[key] ) {
            routeStr = routeStr.replace(String(':' + key).trim(), String(params[key]).trim());
        }
    }
    return routeStr;
}
